import React, { createContext, useContext, useRef, useMemo } from 'react';

type MainContentContextValue = {
  mainContentRef: React.RefObject<HTMLElement>;
};

const MainContentContext = createContext<MainContentContextValue | null>(null);

export const MainContentProvider = ({ children }: React.PropsWithChildren) => {
  const mainContentRef = useRef<HTMLElement>(null);

  const value = useMemo(
    () => ({
      mainContentRef,
    }),
    [mainContentRef],
  );

  return <MainContentContext.Provider value={value}>{children}</MainContentContext.Provider>;
};

export const useMainContent = () => {
  const context = useContext(MainContentContext);
  if (!context) {
    throw new Error('useMainContent must be used within a MainContentProvider');
  }
  return context;
};
